import { render, staticRenderFns } from "./bpb-nav-toc-toggle.vue?vue&type=template&id=300e4634&"
import script from "./bpb-nav-toc-toggle.vue?vue&type=script&lang=js&"
export * from "./bpb-nav-toc-toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports